import React from 'react';
import './styles.scss';
import GDPRshield from './GDPRshield';
import { Icons } from '@hyperping/design';

const WhyChooseHyperping = () => {
  return (
    <div className="flex flex-direction-column width-100 margin-auto" style={{ maxWidth: '1160px' }}>
      <div className="features-monitoring text-align-center justify-content-center mb-2em">
        <h2 className="font-weight-500" style={{ marginBottom: '0' }}>Why choose Hyperping?</h2>
      </div>
      <div className="flex gap-1em">
        <div className="flex flex-direction-column gap-1em justify-content-space-between" style={{ minWidth: '468px', width: '468px' }}>
          <div className="why-choose-block flex flex-direction-column border br-6px padding-2em bg-lighter gap-075em border ">
            <div className="font-size-24px line-height-115em font-weight-500">We're here to serve you, not investors</div>
            <div className="font-size-16px font-weight-300 why-choose-block-p line-height-143em">Public or VC-funded alternatives inevitably raise prices while the experience gets worse and worse. We have no investors to please, so we can focus on pleasing you.</div>
          </div>
          <div className="why-choose-block flex flex-direction-column border br-6px padding-2em bg-lighter gap-075em" style={{ minHeight: '260px', paddingBottom: '0', overflow: 'hidden', position: 'relative' }}>
            <div className="font-size-24px line-height-115em font-weight-500" style={{ zIndex: '1' }}>We care about GDPR as much as you do</div>
            <div className="font-size-16px font-weight-300 why-choose-block-p line-height-143em" style={{ zIndex: '1' }}>We are a French company hosted in EU data centers by EU companies. If it's something important for you, look no further.</div>
            <GDPRshield style={{ opacity: 0.5, transform: 'skew(341deg, 11deg) scale(1.3)', position: 'absolute', right: '-130px', bottom: '-69px', width: '100%', height: '100%' }} />
          </div>
        <div className="font-weight-300 font-size-15px line-height-143em flex align-items-center gap-025em">
          <a href="/why" className="font-weight-400" style={{ color:'#a2a7ff' }}>All the reasons to choose Hyperping →</a>
        </div>
        </div>
        <div className="why-choose-block flex flex-direction-column border br-6px padding-2em bg-lighter gap-075em" style={{ width: '100%' }}>
          <div className="font-size-24px line-height-115em font-weight-500">We have the best feature set at that price point</div>
          <div className="font-size-16px font-weight-300 why-choose-block-p line-height-143em">We have one of the best feature set on the market for a monitoring & status page platform.</div>

          <div className="font-size-22px line-height-115em font-weight-300 mt-05em">Here's what you get for <span className="highlighted-text">$74/mo</span> paid yearly</div>
          <div className="flex align-items-start gap-075em font-size-16px font-weight-300 why-choose-block-p line-height-143em mb-05em">
            <Icons name="globe" size="small" style={{ color: '#2BAC76', minWidth:'18px', minHeight:'18px', strokeWidth: '1px',marginTop:'2px' }} />
            <div className="flex flex-direction-column" style={{ gap:'0.25em' }}>
              <span className="font-weight-500 color-white">Unlimited full-featured status pages</span>
              Custom domains, 1000 subscribers, protected & private pages, multi-language, components, and more.
            </div>
          </div>
          <div className="flex align-items-start gap-075em font-size-16px font-weight-300 why-choose-block-p line-height-143em mb-05em">
            <Icons name="speed" size="small" style={{ color: '#2BAC76', minWidth:'18px', minHeight:'18px', strokeWidth: '1px',marginTop:'2px' }} />
            <div className="flex flex-direction-column" style={{ gap:'0.25em' }}>
              <span className="font-weight-500 color-white">10 synthetic monitors</span>
              Few of our competitors offer them, even fewer at that price.
            </div>
          </div>
          <div className="flex align-items-start gap-075em font-size-16px font-weight-300 why-choose-block-p line-height-143em mb-05em">
            <Icons name="clock" size="small" style={{ color: '#2BAC76', minWidth:'18px', minHeight:'18px', strokeWidth: '1px',marginTop:'2px' }} />
            <div className="flex flex-direction-column">
              <span className="font-weight-500 color-white">100 monitors</span>
              Includes classic monitors and cron job monitors. And a 30s frequency, one of the few platforms to do it.
            </div>
          </div>
          <div className="flex align-items-start gap-075em font-size-16px font-weight-300 why-choose-block-p line-height-143em mb-05em">
            <Icons name="users" size="small" style={{ color: '#2BAC76', minWidth:'18px', minHeight:'18px', strokeWidth: '1px',marginTop:'2px' }} />
            <div className="flex flex-direction-column" style={{ gap:'0.25em' }}>
              <span className="font-weight-500 color-white">5 teammates</span>
              Some alternatives charge on a per user basis making it quickly very expensive. Not us.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WhyChooseHyperping;
